export default __webpack_public_path__ + "static/media/wls.f9e034ed.png";